import { useState, useEffect } from "react";
import "../Styles/ClientPreferences.css";
import PhysicalAttributes from "./PhysicalAttributes";
import LifestyleHabits from "./LifestyleHabits";
import {
  create_matches_by_preference,
  get_client_preferenca,
  get_level2_caste,
  update_client_preferenca,
} from "../api/serverWrapper";
import SalaryRange from "./SalaryRange";
import { calculateAge } from "../utils/commonFunctions";
import { useMasterData } from "../context/MasterDataContext";

const ClientPreferences = ({ UserData }) => {
  const {
    religionMasterData,
    maritalStatusMasterData,
    skinToneMasterData,
    buildMasterData,
    habitsMasterData,
    hobbiesMasterData,
    qualificationMasterData,
    communityMasterData,
    languageMasterData,
    relationsMasterData,
    countryMasterData,
  } = useMasterData();

  console.log("UserData :--", UserData);
  const [ClientPreferencesData, setClientPreferencesData] = useState(null);
  const [gender, setGender] = useState(UserData?.User?.Gender === 1 ? 2 : 1);
  const [ageRange, setAgeRange] = useState([20, 45]);
  const [NoAgePreference, SetNoAgePreference] = useState(false);
  const [maritalStatus, setMaritalStatus] = useState(
    maritalStatusMasterData || [],
  );

  const [religion, setReligion] = useState(religionMasterData || []);
  const [languages, setLanguage] = useState(languageMasterData || []);

  const [level2Caste, setLevel2Caste] = useState([]);
  const [communityList, setCommunity] = useState(communityMasterData || []);
  const [Loading, setLoading] = useState(false);
  const [skinToneList, setSkinToneList] = useState(skinToneMasterData || []);
  const [physicalbuildList, setPhysicalBuildList] = useState(
    buildMasterData || [],
  );
  const [habitList, setHabitList] = useState(habitsMasterData || []);
  const [hobbiesList, setHobbiesList] = useState(hobbiesMasterData || []);
  const [qualifications, setQualifications] = useState(
    qualificationMasterData || [],
  );

  const [relationList, setRelatonList] = useState(relationsMasterData || []);
  const [relationshipStatus, setRelationshipStatus] = useState(
    UserData?.MarriageStatusId || 1,
  );
  const [openToStatus, setOpenToStatus] = useState([]);
  const [kids, setKids] = useState(1);
  const [openToKids, setOpenToKids] = useState([1]);

  const [idealReligion, setIdealReligion] = useState("");
  const [openToReligion, setOpenToReligion] = useState([]);

  const [idealCaste, setIdealCaste] = useState("");
  const [openToCaste, setOpenToCaste] = useState([]);

  const [idealCommunity, setIdealCommunity] = useState("");
  const [openToCommunity, setOpenToCommunity] = useState([]);

  const [idealQualification, setIdealQualification] = useState(
    UserData.QualificationId || "",
  );
  const [openToQualifications, setOpenToQualifications] = useState([]);
  const [minimumSalary, setMinimumSalary] = useState("₹ 3 LPA");
  const [limitSameReligion, setLimitSameReligion] = useState(
    UserData.LimitSameReligion,
  );
  const [limitSameCaste, setLimitSameCaste] = useState(UserData.LimitSameCaste);
  const [limitSameSubCaste, setLimitSameSubCaste] = useState(
    UserData.LimitSameSubCaste,
  );
  const [limitSameSubCommunity, setLimitSameSubCommunity] = useState(
    UserData.LimitSameSubCommunity,
  );
  const [limitLanguage, setLimitLanguage] = useState(UserData.LimitLanguage);

  const [idealCitizenship, setIdealCitizenship] = useState("");
  const [openToCitizenship, setOpenToCitizenship] = useState([]);

  const [idealResidence, setIdealResidence] = useState("");
  const [openToResidence, setOpenToResidence] = useState([]);

  // From PhysicalAttributes
  const [unit, setUnit] = useState("metric");
  const [skinIdeal, setSkinIdeal] = useState(1);
  const [skinOpen, setSkinOpen] = useState([]);
  const [buildIdeal, setBuildIdeal] = useState(1);
  const [buildOpen, setBuildOpen] = useState([]);
  const [heightRange, setHeightRange] = useState([5.5, 6.5]);
  const [weightRange, setWeightRange] = useState([30, 55]);
  const [noPrefHeight, setNoPrefHeight] = useState(false);
  const [noPrefWeight, setNoPrefWeight] = useState(false);
  const [salaryRange, setSalaryRange] = useState([0, 0]);
  const [NoSalaryPreferance, setNoSalaryPreferance] = useState(true);
  const [selectedHabits, setSelectedHabits] = useState([]);
  const [selectedHobbies, setSelectedHobbies] = useState([]);
  const genders = [
    { id: 1, gender: "Men" },
    { id: 2, gender: "Women" },
    { id: 3, gender: "Others" },
  ];

  useEffect(() => {
    setLoading(true);
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      const [Client_Preferences] = await Promise.all([
        get_client_preferenca(UserData.ProfileId),
      ]);

      setClientPreferencesData(Client_Preferences.data);

      const pref = Client_Preferences.data;

      console.log("pref", pref);
      console.log(UserData.User.Gender);

      if (pref) {
        setGender(pref.GenderPreferenceId);

        // Age
        if (pref.AgePreference) {
          setAgeRange(pref.AgePreference.split("-").map(Number));
        }

        SetNoAgePreference(pref.NoAgePreference);

        // Height
        if (pref.HeightPreferance?.includes("-")) {
          const [minHeight, maxHeight] = pref.HeightPreferance.split("-").map(
            (val) => parseFloat(val.trim()),
          );
          setHeightRange([minHeight, maxHeight]);
        }

        // Weight
        if (pref.WeightPreferance?.includes("-")) {
          const [minWeight, maxWeight] = pref.WeightPreferance.replace(
            /kg/gi,
            "",
          )
            .split("-")
            .map((val) => parseFloat(val.trim()));
          setWeightRange([minWeight, maxWeight]);
        }

        
        if(pref.IdealToMaritalStatus){
            setRelationshipStatus(pref.IdealToMaritalStatus);
        }
        else{
          setRelationshipStatus(UserData?.MarriageStatusId);
        }

         
        if (pref.OpenToMaritalStatus) {
          setOpenToStatus(pref.OpenToMaritalStatus);
        }

        if (pref.IdealReligionPreferance) {
          setIdealReligion(pref.IdealReligionPreferance);
          await getlevl2Caste(pref.IdealReligionPreferance, null);
        } else {
          setIdealReligion(UserData.ReligionId);
          await getlevl2Caste(UserData.ReligionId, null);
          await getOpenToCaste(UserData.ReligionId, null);
        }

       

        let religionIds = [];

        if (Array.isArray(pref.OpenToReligionPreferance)) {
          religionIds.push(...pref.OpenToReligionPreferance);
        }

        if (pref.IdealReligionPreferance) {
          religionIds.push(pref.IdealReligionPreferance);
        }

        const uniqueReligionIds = [...new Set(religionIds)];

        if (pref.OpenToReligionPreferance.length > 0) {
          setOpenToReligion(pref.OpenToReligionPreferance);
        }

        for (const religionId of uniqueReligionIds) {
          await getOpenToCaste(religionId);
        }

        if (pref.IdealCastePreferance) {
          setIdealCaste(pref.IdealCastePreferance);
        } else {
          setIdealCaste(UserData.CasteLevel2Id);
        }

        if (pref.OpenToCastePreferance) {
          setOpenToCaste(pref.OpenToCastePreferance);
        }
        if (pref.IdealCommunityPreferance) {
          setIdealCommunity(pref.IdealCommunityPreferance);
        } else {
          setIdealCommunity(UserData.CommunitiesId);
        }

        if (pref.OpenToCommunityPreferance) {
          setOpenToCommunity(pref.OpenToCommunityPreferance);
        }

        if(pref.IdealEducationPreferance){
          setIdealQualification(pref.IdealEducationPreferance);
        }
        else{
           setIdealQualification(UserData.QualificationId || "");
        }

        

         
        setOpenToQualifications(pref.OpenToEducationPreferance);

        setMinimumSalary(pref.SalaryPreferance);
        // setSalaryRange(pref.SalaryPreferance);
        setNoSalaryPreferance(pref.NoSalaryPreferance);
        if (pref.SalaryPreferance?.includes("-")) {
          const [minSal, maxSal] = pref.SalaryPreferance.split("-").map((val) =>
            parseFloat(val.trim()),
          );

          setSalaryRange([minSal, maxSal]);
        }

        setSkinIdeal(pref.IdealSkinTone);
        if (pref.OpenToSkinTone.length > 0) {
          setSkinOpen(pref.OpenToSkinTone);
        }

        setBuildIdeal(pref.IdealBuildPreferance);
        if (pref.OpenToBuildPreferance.length > 0) {
          setBuildOpen(pref.OpenToBuildPreferance);
        }

        setSelectedHabits(pref.HabitsPreferance);
        setSelectedHobbies(pref.HobbiesPreferance);

        // console.log(UserData.User.Address.CitizenshipId);

        if (pref.IdealCitizenshipPreferance) {
          setIdealCitizenship(pref.IdealCitizenshipPreferance || "");
        } else {
          setIdealCitizenship(UserData.User.Address?.CitizenshipId || "");
        }
        setOpenToCitizenship(pref.OpenToCitizenshipPreferance || []);

        if (pref.IdealResidencePreferance) {
          setIdealResidence(pref.IdealResidencePreferance || "");
        } else {
          setIdealResidence(UserData.User.Address?.ResidenceId || "");
        }

        setOpenToResidence(pref.OpenToResidencePreferance || []);
      } else {

        console.log(UserData);
        
        
        setIdealQualification(UserData.QualificationId || "");
        setIdealReligion(UserData.ReligionId);
        setIdealCaste(UserData.CasteLevel2Id);
        setIdealCommunity(UserData.CommunitiesId);
        setIdealCitizenship(UserData.User.Address?.CitizenshipId || "");
        setIdealResidence(UserData.User.Address?.ResidenceId || "");

        await getlevl2Caste(UserData.ReligionId, null);
        await getOpenToCaste(UserData.ReligionId);

        let gender = UserData?.User?.Gender;

        if (gender === 1) {
          let age = calculateAge(UserData?.User?.DOB);
          let min;
          let max = age;

          min = age - 10;

          if (min <= 18) {
            min = 18;
          }

          if (age === 18) {
            max = 19;
          }

          setAgeRange([min, max]);
        } else if (gender === 2) {
          let age = calculateAge(UserData?.User?.DOB);
          let min = age;
          let max = age + 10;

          setAgeRange([min, max]);
        }

        if (UserData?.Weight) {
          const weight = Number(UserData.Weight);

          let wMin, wMax;

          if (gender === 1) {
            // Male
            wMin = weight - 10;
            wMax = weight;
          } else if (gender === 2) {
            // Female
            wMin = weight;
            wMax = weight + 10;
          }

          if (wMin < 0) wMin = 0;

          setWeightRange([wMin, wMax]);
        }

        if (UserData?.Height) {
          const height = Number(UserData.Height);

          let hMin, hMax;

          if (gender === 1) {
            // Male
            hMin = height - 0.5;
            hMax = height;
          } else if (gender === 2) {
            // Female
            hMin = height;
            hMax = height + 0.6;
          }

          if (hMin < 0) hMin = 0;

          setHeightRange([Number(hMin.toFixed(1)), Number(hMax.toFixed(1))]);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getlevl2Caste = async (selectedReligion, id) => {
    let data = await get_level2_caste(selectedReligion, id);
    console.log("get level2 caste", data);
    setLevel2Caste(data.data);
  };

  const handleToggleQualification = (value) => {
    setOpenToQualifications((prev) =>
      prev.includes(value) ? prev.filter((q) => q !== value) : [...prev, value],
    );
  };

  // const handleToggleReligion = async (value) => {
  //   let updated = openToReligion.includes(value)
  //     ? openToReligion.filter((q) => q !== value)
  //     : [...openToReligion, value];

  //   setOpenToReligion(updated);

  //   // also refresh caste list (if required)
  //   await getOpenToCaste(Number(value), null);
  // };

  const handleToggleReligion = async (value) => {
    const religionId = Number(value);

    // Remove Religion
    if (openToReligion.includes(religionId)) {
      const updatedReligions = openToReligion.filter(
        (id) => Number(id) !== religionId,
      );

      setOpenToReligion(updatedReligions);

      // Get castes of removed religion
      const casteResp = await get_level2_caste(religionId);

      const casteIdsToRemove = casteResp.data.map((item) => item.CasteL2Id);

      // Remove those castes from selected Open To Caste
      setOpenToCaste((prev) =>
        prev.filter((casteId) => !casteIdsToRemove.includes(Number(casteId))),
      );

      // Remove from caste dropdown data also
      setOpenToCasteData((prev) =>
        prev.filter((item) => !casteIdsToRemove.includes(item.CasteL2Id)),
      );
    } else {
      // Add Religion
      setOpenToReligion((prev) => [...prev, religionId]);

      await getOpenToCaste(religionId);
    }
  };

  const getOpenToCaste = async (id) => {
    console.log("getOpenToCasteid", id);

    let data = await get_level2_caste(id);

    setOpenToCasteData((prev) => {
      const merged = [...prev, ...data.data];

      // remove duplicates using CasteL2Id
      const unique = [
        ...new Map(merged.map((item) => [item.CasteL2Id, item])).values(),
      ];

      return unique;
    });
  };

  const handleToggleCaste = (value) => {
    setOpenToCaste((prev) =>
      prev.includes(value) ? prev.filter((q) => q !== value) : [...prev, value],
    );
  };
  const handleToggleCommunite = (value) => {
    setOpenToCommunity((prev) =>
      prev.includes(value) ? prev.filter((q) => q !== value) : [...prev, value],
    );
  };

  const toggleOption = (value, setFn, state) => {
    if (state.includes(value)) {
      setFn(state.filter((item) => item !== value));
    } else {
      setFn([...state, value]);
    }
  };

  const renderMaritalStatusOptions = () => {
    return maritalStatus.map((item) => (
      <option key={item.MarriageStatusId} value={item.MarriageStatusId}>
        {item.MarriageStatus}
      </option>
    ));
  };

  const renderEducationalOptions = () => {
    return qualifications.map((item) => (
      <option key={item.QualificationId} value={item.QualificationId}>
        {item.QualificationName}
      </option>
    ));
  };

  const renderReligion = () => {
    return religion.map((item, index) => (
      <option key={index} value={item.ReligionId}>
        {item.ReligionName}
      </option>
    ));
  };

  const renderLevel2Caste = () => {
    return level2Caste?.map((item, index) => (
      <option key={index} value={item.CasteL2Id}>
        {item.CasteName}
      </option>
    ));
  };

  const [OpenToCasteData, setOpenToCasteData] = useState([]);

  const renderCommunity = () => {
    return communityList.map((item, index) => (
      <option key={index} value={item.CommunitiesId}>
        {item.CommunitiesName}
      </option>
    ));
  };

  const handleReligion = async (e) => {
    setIdealReligion(e.target.value);
    await getlevl2Caste(Number(e.target.value));
  };

  const handleToggleCitizenship = (value) => {
    setOpenToCitizenship((prev) =>
      prev.includes(value)
        ? prev.filter((id) => id !== value)
        : [...prev, value],
    );
  };

  const handleToggleResidence = (value) => {
    setOpenToResidence((prev) =>
      prev.includes(value)
        ? prev.filter((id) => id !== value)
        : [...prev, value],
    );
  };

  const [isSaving, setIsSaving] = useState(false);

  const updateClientPreferance = async () => {
    try {
      setIsSaving(true);

      if (salaryRange[0] === 0 && salaryRange[1] === 0) {
        alert("Fill the salary range");
        setIsSaving(false);
        return;
      }

      const preferenceData = {
        ClientId: UserData.ProfileId,
        GenderPreferenceId: gender,
        AgePreference: `${ageRange[0]}-${ageRange[1]}`,
        NoAgePreference: NoAgePreference,
        IdealToMaritalStatus: relationshipStatus,
        OpenToMaritalStatus: openToStatus,
        IdealKidsPreference: kids,
        OpenToKidsPreference: openToKids,
        IdealEducationPreferance: idealQualification,
        OpenToEducationPreferance: openToQualifications,
        SalaryPreferance: `${salaryRange[0]} - ${salaryRange[1]}`,
        NoSalaryPreferance: NoSalaryPreferance,
        HeightPreferance: `${heightRange[0]} - ${heightRange[1]}`,
        WeightPreferance: `${weightRange[0]}kg - ${weightRange[1]}kg`,
        IdealSkinTone: skinIdeal,
        OpenToSkinTone: skinOpen,
        IdealBuildPreferance: buildIdeal,
        OpenToBuildPreferance: buildOpen,
        HabitsPreferance: selectedHabits,
        HobbiesPreferance: selectedHobbies,
        IdealReligionPreferance: idealReligion,
        OpenToReligionPreferance: openToReligion,
        IdealCastePreferance: idealCaste,
        OpenToCastePreferance: openToCaste,
        IdealCommunityPreferance: idealCommunity,
        OpenToCommunityPreferance: openToCommunity,
        IdealCitizenshipPreferance: idealCitizenship,
        OpenToCitizenshipPreferance: openToCitizenship,

        IdealResidencePreferance: idealResidence,
        OpenToResidencePreferance: openToResidence,
      };

      if (!gender) {
        delete preferenceData.GenderPreferenceId;
      }

      if (!idealReligion) {
        delete preferenceData.IdealReligionPreferance;
      }

      if (!idealQualification) {
        delete preferenceData.IdealEducationPreferance;
      }

      if (!idealCaste) {
        delete preferenceData.IdealCastePreferance;
      }

      if (!idealCommunity) {
        delete preferenceData.IdealCommunityPreferance;
      }

      if (!preferenceData.IdealCitizenshipPreferance) {
        delete preferenceData.IdealCitizenshipPreferance;
      }
      if (!preferenceData.IdealResidencePreferance) {
        delete preferenceData.IdealResidencePreferance;
      }

      if (ClientPreferencesData) {
        preferenceData.PreferenceId = ClientPreferencesData.PreferenceId;
      } else {
        delete preferenceData.PreferenceId;
      }

      console.log("preferenceData Data  ", preferenceData);

      // return
      let resp = await update_client_preferenca(preferenceData);
      console.log(resp);
      if (resp.success) {
        loadInitialData();

        let data = {
          profileId: UserData.ProfileId,
        };

        // runMatchesAloritm(data);

        const toast = document.getElementById("custom-toast");
        toast.style.display = "block";

        setTimeout(() => {
          toast.style.display = "none";
        }, 3000);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsSaving(false); // STOP spinner
    }
  };

  

  if (Loading) {
    return (
      <div
        style={{ position: "absolute", left: "50%" }}
        className="d-flex justify-content-center align-items-center vh-100"
      >
        <div
          className="spinner-border"
          role="status"
          style={{ color: "#E1486E" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center  w-100 flex-column">
      <div className="container-1 p-4 ">
        <h4 className="mb-4 text-center section-title">General information</h4>

        {/* Gender */}
        <div className="mb-3">
          <label className="form-label-title">Gender</label>
          <br />
          {genders.map((g, i) => (
            <button
              key={i}
              className={`gender-button me-2 ${
                gender === g.id ? "gender-selected" : "gender-unselected"
              } click-effect`}
              onClick={() => setGender(g.id)}
            >
              {g.gender}
            </button>
          ))}
        </div>

        {/* Age */}
        <div className="mb-4">
          <label className="form-label-title">Age</label>

          <div className="age-slider-container mt-2">
            <div className="d-flex justify-content-between align-items-center age-header">
              <span className="age-range-text">
                {ageRange[0]}yrs - {ageRange[1]} yrs
              </span>
              {/* <div className="no-pref">
                <input
                  type="checkbox"
                  id="noPref"
                  checked={NoAgePreference}
                  onChange={(e) => SetNoAgePreference(e.target.checked)}
                />
                <label htmlFor="noPref" className="ms-2">
                  no preference
                </label>
              </div> */}
            </div>

            <div className="slider-wrapper">
              <div className="slider-track"></div>

              <input
                type="range"
                min="18"
                max="100"
                value={ageRange[0]}
                onChange={(e) => {
                  const value = Math.min(
                    Number(e.target.value),
                    ageRange[1] - 1,
                  );
                  setAgeRange([value, ageRange[1]]);
                }}
                className="slider thumb-left"
              />
              <input
                type="range"
                min="18"
                max="100"
                value={ageRange[1]}
                onChange={(e) => {
                  const value = Math.max(
                    Number(e.target.value),
                    ageRange[0] + 1,
                  );
                  setAgeRange([ageRange[0], value]);
                }}
                className="slider thumb-right"
              />
            </div>

            <div className="d-flex justify-content-between slider-labels mt-2">
              <span>18 yrs</span>
              <span>100 + yrs</span>
            </div>
          </div>
        </div>

        {/* Relationship Status */}
        <div className="mb-3">
          <label className="form-label-title">Relationship Status</label>
          <div className="sub-label">Ideal</div>
          <select
            className="form-select mb-2"
            value={relationshipStatus}
            onChange={(e) => setRelationshipStatus(e.target.value)}
          >
            {renderMaritalStatusOptions()}
          </select>
          <div className="sub-label">Open to</div>
          <div className="button-group">
            {maritalStatus.map((status, i) => (
              <button
                key={i}
                className={`status-button me-2 mb-2 ${
                  openToStatus.includes(status.MarriageStatusId)
                    ? "status-selected"
                    : "status-unselected"
                } click-effect`}
                onClick={() =>
                  toggleOption(
                    status.MarriageStatusId,
                    setOpenToStatus,
                    openToStatus,
                  )
                }
              >
                {status.MarriageStatus}
              </button>
            ))}
          </div>
        </div>

        <div className="section">
          <label className="section-label">Religion Preferences</label>

          <div className="sub-label">Ideal</div>
          <select
            className="custom-select"
            value={idealReligion}
            onChange={handleReligion}
            // disabled={limitSameReligion}
          >
            {renderReligion()}
          </select>

          <div className="sub-label mt-2">Open to Religion</div>
          <div className="custom-multi-select mt-3">
            {openToReligion.map((rId) => {
              const religions = religion.find(
                (r) => r.ReligionId.toString() === rId.toString(),
              );

              return (
                <span key={rId} className="chip">
                  {religions?.ReligionName || rId}
                  <span
                    className="remove"
                    onClick={() => handleToggleReligion(rId)}
                  >
                    ×
                  </span>
                </span>
              );
            })}

            <select
              className="custom-select transparent-select"
              onChange={(e) => handleToggleReligion(e.target.value)}
              value=""
              // disabled={limitSameReligion}
            >
              <option value="" disabled>
                Select Religion
              </option>
              {religion
                .filter(
                  (opt) => !openToReligion.map(Number).includes(opt.ReligionId),
                )
                .map((opt) => (
                  <option key={opt.ReligionId} value={opt.ReligionId}>
                    {opt.ReligionName}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div className="section">
          <label className="section-label">Caste Preferences</label>

          <div className="sub-label">Ideal</div>
          <select
            className="custom-select"
            value={idealCaste}
            onChange={(e) => setIdealCaste(e.target.value)}
            // disabled={limitSameSubCaste}
          >
            <option value=""> Select Caste </option>
            {renderLevel2Caste()}
          </select>

          <div className="sub-label mt-2">Open to Caste</div>
          <div className="custom-multi-select mt-3">
            {openToCaste.map((cId) => {
              const castes = OpenToCasteData?.find(
                (r) => r.CasteL2Id.toString() === cId.toString(),
              );

              return (
                <span key={cId} className="chip">
                  {castes?.CasteName || cId}
                  <span
                    className="remove"
                    onClick={() => handleToggleCaste(cId)}
                  >
                    ×
                  </span>
                </span>
              );
            })}

            <select
              className="custom-select transparent-select"
              onChange={(e) => handleToggleCaste(e.target.value)}
              value=""
              // disabled={limitSameSubCaste}
            >
              <option value="" disabled>
                Select Caste
              </option>
              {OpenToCasteData.filter(
                (opt) => !openToCaste.map(Number).includes(opt.CasteL2Id),
              ).map((opt) => (
                <option key={opt.CasteL2Id} value={opt.CasteL2Id}>
                  {opt.CasteName}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="section">
          <label className="section-label">Community Preferences</label>

          <div className="sub-label">Ideal</div>
          <select
            className="custom-select"
            value={idealCommunity}
            onChange={(e) => setIdealCommunity(e.target.value)}
          >
            {renderCommunity()}
          </select>

          <div className="sub-label mt-2">Open to Communities</div>
          <div className="custom-multi-select mt-3">
            {openToCommunity.map((qId) => {
              const idealCommunitys = communityList.find(
                (r) => r.CommunitiesId.toString() === qId.toString(),
              );

              return (
                <span key={qId} className="chip">
                  {idealCommunitys?.CommunitiesName || qId}
                  <span
                    className="remove"
                    onClick={() => handleToggleCommunite(qId)}
                  >
                    ×
                  </span>
                </span>
              );
            })}

            <select
              className="custom-select transparent-select"
              onChange={(e) => handleToggleCommunite(e.target.value)}
              value=""
            >
              <option value="" disabled>
                Select Community
              </option>
              {communityList
                .filter(
                  (opt) =>
                    !openToCommunity.map(Number).includes(opt.CommunitiesId),
                )
                .map((opt) => (
                  <option key={opt.CommunitiesId} value={opt.CommunitiesId}>
                    {opt.CommunitiesName}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div className="section">
          <label className="section-label">Citizenship Preferences</label>

          <div className="sub-label">Ideal</div>
          <select
            className="custom-select"
            value={idealCitizenship}
            onChange={(e) => setIdealCitizenship(e.target.value)}
          >
            <option value="">Select Citizenship</option>
            {countryMasterData?.map((country) => (
              <option key={country.id} value={country.id}>
                {country.CountryName} ({country.CountryCode})
              </option>
            ))}
          </select>

          <div className="sub-label mt-2">Open to</div>
          <div className="custom-multi-select mt-3">
            {openToCitizenship.map((id) => {
              const country = countryMasterData.find(
                (c) => c.id.toString() === id.toString(),
              );

              return (
                <span key={id} className="chip">
                  {country?.CountryName || id}
                  <span
                    className="remove"
                    onClick={() => handleToggleCitizenship(id)}
                  >
                    ×
                  </span>
                </span>
              );
            })}

            <select
              className="custom-select transparent-select"
              onChange={(e) => handleToggleCitizenship(e.target.value)}
              value=""
            >
              <option value="" disabled>
                Select Citizenship
              </option>
              {countryMasterData
                .filter((c) => !openToCitizenship.map(Number).includes(c.id))
                .map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CountryName} ({c.CountryCode})
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div className="section">
          <label className="section-label">Residence Preferences</label>

          <div className="sub-label">Ideal</div>
          <select
            className="custom-select"
            value={idealResidence}
            onChange={(e) => setIdealResidence(e.target.value)}
          >
            <option value="">Select Residence</option>
            {countryMasterData?.map((country) => (
              <option key={country.id} value={country.id}>
                {country.CountryName} ({country.CountryCode})
              </option>
            ))}
          </select>

          <div className="sub-label mt-2">Open to</div>
          <div className="custom-multi-select mt-3">
            {openToResidence.map((id) => {
              const country = countryMasterData.find(
                (c) => c.id.toString() === id.toString(),
              );

              return (
                <span key={id} className="chip">
                  {country?.CountryName || id}
                  <span
                    className="remove"
                    onClick={() => handleToggleResidence(id)}
                  >
                    ×
                  </span>
                </span>
              );
            })}

            <select
              className="custom-select transparent-select"
              onChange={(e) => handleToggleResidence(e.target.value)}
              value=""
            >
              <option value="" disabled>
                Select Residence
              </option>
              {countryMasterData
                .filter((c) => !openToResidence.map(Number).includes(c.id))
                .map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CountryName} ({c.CountryCode})
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>

      <div className="container-1 p-4 mt-2">
        <h4 className="section-title">Education and career</h4>

        <div className="section">
          <label className="section-label">Educational Qualification</label>

          <div className="sub-label">Ideal</div>
          <select
            className="custom-select"
            value={idealQualification}
            onChange={(e) => setIdealQualification(e.target.value)}
          >
            {renderEducationalOptions()}
          </select>

          <div className="sub-label">Open to</div>
          <div className="custom-multi-select">
            {openToQualifications.map((qId) => {
              const qualification = qualifications.find(
                (q) => q.QualificationId.toString() === qId.toString(),
              );

              return (
                <span key={qId} className="chip">
                  {qualification?.QualificationName || qId}
                  <span
                    className="remove"
                    onClick={() => handleToggleQualification(qId)}
                  >
                    ×
                  </span>
                </span>
              );
            })}

            <select
              className="custom-select transparent-select"
              onChange={(e) => handleToggleQualification(e.target.value)}
              value=""
            >
              <option value="" disabled>
                Select qualification
              </option>
              {qualifications
                .filter(
                  (opt) =>
                    !openToQualifications
                      .map(Number)
                      .includes(opt.QualificationId),
                )
                .map((opt) => (
                  <option key={opt.QualificationId} value={opt.QualificationId}>
                    {opt.QualificationName}
                  </option>
                ))}
            </select>
          </div>
        </div>

        {/* Salary */}
        {/* <div className="section">
          <label className="section-label">Salary</label>
          <div className="sub-label">Minimum salary</div>
          <input
            type="text"
            className="custom-select"
            value={minimumSalary}
            onChange={(e) => setMinimumSalary(e.target.value)}
            placeholder="e.g., ₹ 20 LPA"
          />
        </div> */}

        <SalaryRange
          salaryRange={salaryRange}
          setSalaryRange={setSalaryRange}
          NoPrefSalary={NoSalaryPreferance}
          setNoPrefSalary={setNoSalaryPreferance}
          salaryCurrency={UserData?.SalaryCurrency}
        />
      </div>
      <PhysicalAttributes
        skinToneList={skinToneList}
        physicalbuildList={physicalbuildList}
        unit={unit}
        setUnit={setUnit}
        skinIdeal={skinIdeal}
        setSkinIdeal={setSkinIdeal}
        skinOpen={skinOpen}
        setSkinOpen={setSkinOpen}
        buildIdeal={buildIdeal}
        setBuildIdeal={setBuildIdeal}
        buildOpen={buildOpen}
        setBuildOpen={setBuildOpen}
        heightRange={heightRange}
        setHeightRange={setHeightRange}
        weightRange={weightRange}
        setWeightRange={setWeightRange}
        noPrefHeight={noPrefHeight}
        setNoPrefHeight={setNoPrefHeight}
        noPrefWeight={noPrefWeight}
        setNoPrefWeight={setNoPrefWeight}
      />
      <LifestyleHabits
        habitList={habitList}
        hobbiesList={hobbiesList}
        selectedHabits={selectedHabits}
        setSelectedHabits={setSelectedHabits}
        selectedHobbies={selectedHobbies}
        setSelectedHobbies={setSelectedHobbies}
      />

      <button
        className="finish-button mt-4 mb-4 click-effect"
        onClick={updateClientPreferance}
        disabled={isSaving}
      >
        {isSaving ? <span className="spinner"></span> : "Save Preferences"}
      </button>

      <div id="custom-toast">Preferance Saved successfully!</div>
    </div>
  );
};

export default ClientPreferences;
